import IconWaffle from '@bimser/icons/16/waffle';
import { FC } from 'react';
import BCButton from '../BCButton';
import BCDrawer from '../BCDrawer';
import BCTabs from '../BCTabs';
import Styles from './assets/styles.scss';
import { BCDrawerPanelProps } from './entities';

const containerStyles: React.CSSProperties = {
	height: '100%',
	backgroundImage:
		'url("' +
		((window as any).serviceConfig?.DomainAddress || (window as any).DomainAddress || '.') +
		'/images/Theme4.webp")',
	backgroundRepeat: 'no-repeat',
	backgroundPosition: 'center top',
	backgroundSize: 'cover'
};

const BCDrawerPanel: FC<BCDrawerPanelProps> = ({ open, onClose, tabProps }) => {
	return (
		<BCDrawer
			width={625}
			closable={false}
			className={Styles.drawer}
			open={open}
			placement="left"
			maskClosable={true}
			onClose={onClose}
		>
			<div style={containerStyles}>
				<div className={Styles.header}>
					<BCButton
						type="link"
						size="large"
						icon={<IconWaffle />}
						onClick={onClose}
					/>
					<span>BimserSynergy</span>
				</div>
				<div className={Styles.tabContainer}>
					<BCTabs {...tabProps} />
				</div>
			</div>
		</BCDrawer>
	);
};

export { BCDrawerPanelProps };
export default BCDrawerPanel;
